import { render, staticRenderFns } from "./WorkloadSection.vue?vue&type=template&id=2f4df884"
import script from "./WorkloadSection.vue?vue&type=script&lang=js"
export * from "./WorkloadSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports